<template>
  <div class="main">
    <report-top>
      <template slot="search">
        <ly-search
          v-model="searchItem.keyword"
          placeholder="输入搜索关键词"
          @search="searchResult"
          search
        />
      </template>
    </report-top>

    <selectTool ref="selectTool"
      ><template slot="btn"
        ><Button @click="getSearchItem" type="error" class="chaxun"
          >查询</Button
        ></template
      ></selectTool
    >
    <Table
      border
      :columns="columns1"
      :data="tableData"
      :height="utils.setTableHeight(200)"
    >
      <template slot-scope="{ row, index }" slot="detail">
        <Button size="small" @click="detail(row)">查看明细</Button>
      </template>
    </Table>
    <div id="mypage">
      <div>
        <Page
          :total="total"
          :current="1"
          :page-size="searchItem.pageSize"
          show-elevator
          show-total
          @on-change="changePage"
        ></Page>
      </div>
    </div>
  </div>
</template>
<script>
import lySearch from "../lySearch.vue";
export default {
  components: { lySearch },
  data() {
    return {
      columns1: [
        {
          type: "index",
          align: "center",
        },
        {
          title: "登录账号",
          key: "account",
        },
        {
          title: "ip地址",
          key: "ip",
        },{
          title: "地理位置",
          key: "address",
        },
        {
          title: "来源",
          key: "laiyuan",
          tooltip: true,
        },
        
        {
          title: "登录时间",
          key: "operateTime",
          render: (h, data) => {
            return h("div", this.utils.time(data.row.recordTime));
          },
          tooltip: true,
        },
        {
          title: "成功与否",
          key: "cgyf",
          tooltip: true,
        },
      ],
      tableData: [],
      total: 0,

      searchItem: {
        keyword: "",
        pageNumber: 1,
        pageSize: 50,
        startTime: "",
        endTime: "",
      },
      searchForms: [
        /*{
          title: "类型分类",
          key: "categorys",
          type: "Select",
          selectItems: categorys,
        },*/
        {
          title: "时间范围",
          key: "startTime",
          key1: "endTime",
          type: "lyyymmdd",
          times: "2,0",
        },
      ],
    };
  },

  methods: {
    getReportData() {
      this.utils.loading(this, "加载中");

      this.axios({
        method: "post",
        url:this.axios.com+"/loginLog/list",
        data: this.searchItem,
      }).then((res) => {
        this.$Spin.hide(); //关闭加载
        this.total = res.data.data.total;
        var data = res.data.data.dataList;
         for (const i in data) {
          data[i].cgyf=this.lydic.cgyf[data[i].status];
          data[i].laiyuan=this.lydic.laiyuan[data[i].channel];
        }
        this.tableData = data;
      });
    },
    //表格分页
    changePage(x) {
      this.searchItem.pageNumber = x;
      this.getReportData();
    },
    searchResult(x) {
      this.keyword = x;
      this.getReportData();
    },
    getSearchItem() {
      this.searchItem = this.$refs.selectTool.getItem();
      this.getReportData();
    },
    reMsg(v) {},
  },
  mounted() {
    this.$refs.selectTool.reach(this.searchForms, this.searchItem);
    setTimeout(() => {
      this.getSearchItem();
    }, 200);
  },
};
</script>


// WEBPACK FOOTER //
// ../common/src/components/log/loginLog.vue